<template>
  <v-app>
    <transition name="fade">
      <div
        v-if="(authorize == 'registration' || $store.getters.currentUserIsVisitor)  && loaded"
        fluid
        class="d-flex flex-column bg-color-min"
      >
        <div class="bg-b">
          <v-container>
            <v-row align="center" class="my-2">
              <v-col cols="4">
                <div class="d-flex justify-sm-start align-center">
                  <img
                    :height="$vuetify.breakpoint.smAndDown ? '20px' : '40px'"
                    :width="$vuetify.breakpoint.smAndDown ? '60px' : '130px'"
                    :src="$store.getters.registrationPanelLogo"
                    alt="Logo"
                  />
                </div>
              </v-col>
              <v-col cols="4" class="text-center">
                <h3 class="float-rigth">فرم عضویت</h3>
              </v-col>
              <v-col cols="4">
                <v-btn
                  v-if="!this.$store.getters.currentUserIsVisitor"
                  :href="taksaanUrl"
                  target="_blank"
                  class="font-16 float-left"
                  text
                  role="link"
                  >بازگشت به سایت
                </v-btn>
                <v-btn
                  v-if="this.$store.getters.currentUserIsVisitor"
                  @click="$router.push({ path:`/dashboard`  })"
                  target="_blank"
                  class="font-16 float-left"
                  text
                  role="link"
                >
                   بازگشت به پنل(شما بازایاب تکصان هستید)            
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <v-container>
          <v-row class="d-flex">
            <v-col cols="4" class="bg-r" v-if="$vuetify.breakpoint.mdAndUp">
              <div class="px-5 white--text" v-html="body"></div>
            </v-col>
            <v-col cols="12" md="8" class="bg-l">
              <router-view />
            </v-col>
            <v-col cols="12" class="bg-r" v-if="$vuetify.breakpoint.smAndDown">
              <div class="px-5 white--text" v-html="body"></div>
            </v-col>
          </v-row>
        </v-container>
        <div class="bg-bb">
          <v-container>
            <v-row align="center" justify="center" class="py-4">
              <v-col v-if="$vuetify.breakpoint.width >= 996" cols="12"> </v-col>
              <v-col cols="6" md="8" align-self="center">
                <span
                  v-if="$vuetify.breakpoint.width >= 996"
                  class="font-12 ma-1 yellow--link"
                >
                  <v-icon color="#EED70C">mdi-map-marker-outline</v-icon>
                  {{ $store.getters.footerAddressRegistrationPanel }}
                </span>
                <span>
                  <v-icon color="#EED70C">mdi-phone</v-icon>
                  {{ $store.getters.footerPhoneRegistrationPanel }}
                </span>
                <div class="font-12 ma-1"></div>
              </v-col>
              <v-col cols="6" md="4" class="text-left">
                <div @click="logOut()" role="button">
                  <span>خروج</span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </transition>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
import Swal from 'sweetalert2';
const pagesRepository = () => RepoFactory.get('pages');

export default {
  head() {
    return {
      rel: 'stylesheet',
      href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
    };
  },
  name: 'RegisterLayout',
  data() {
    return {
      backButtonPrevented: false,
      loaded: false,
      title: '',
      body: '',
    };
  },
  computed: {
    regitrationTypeUrl() {
      if (window.location.pathname == '/consumer-registration') {
        return '/business-registration';
      } else {
        return '/consumer-registration';
      }
    },
    ...mapGetters([
      'uniquePageName',
      'uniquePageNameBuyers',
      'taksaanAcademyUrl',
      'taksaanUrl',
      'contentBaseUrl',
      'authorize',
    ]),
  },
  methods: {
    ...mapActions('oidc', ['signOutOidc']),
    popStateListener(event) {
      if (this.backButtonPrevented === false) {
        history.pushState(null, document.title, location.href);
        Swal.fire({
          html: `شما در حال ترک عملیات نا تمام هستید و اطلاعات ثبت شده از بین خواهد رفت. آیا مطمئن به ترک این بخش بدون اتمام عملیات هستید؟`,
          icon: 'warning',
          confirmButtonText: ' بلی',
          showCancelButton: true,
          cancelButtonText: 'خیر',
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.removeEventListener('popstate', this.popStateListener);
            history.go(-1);
          }
        });
      } else {
        window.removeEventListener('popstate', this.popStateListener);
      }
    },
    logOut() {
      this.signOutOidc();
    },
    taksaan() {
      window.location.href = this.taksaanUrl;
    },
    async getData() {
      try {
        let params = null;
        if (window.location.pathname == '/consumer-registration') {
          params = {
            uniquePageName: this.uniquePageNameBuyers,
          };
        } else {
          params = {
            uniquePageName: this.uniquePageName,
          };
        }
        const { data } = await pagesRepository().getUniquePage(
          this.contentBaseUrl,
          {},
          params
        );
        this.title = data.title;
        this.body = data.body;
        this.loaded = true;
      } catch (error) {
        //console.log('catch');

        this.loaded = true;
      }
    },
    openTempMerchantList() {
      
    },
  },
  destroyed() {
    this.backButtonPrevented = true;
    this.popStateListener();
  },
  mounted() {
    this.getData();
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', this.popStateListener);
  },
};
</script>

<style>
/* .a{
  color: bisque;
} */
._blank {
  max-width: 1280px !important;
  height: 100vh;
}
.bg-b {
  background-color: #e5e5e5 !important;
  min-height: 60px !important;
}
.bg-bb {
  background-color: #e5e5e5 !important;
}
.bg-r {
  background-color: #fd9300;
  overflow-y: scroll;
}
.bg-l {
  padding: 0;
  background-color: white;
}
.noaction {
  border: non !important;
  box-shadow: none !important;
}
.h--100 {
  height: 100vh !important;
}
.bg-color-min {
  background-color: #e5e5e5 !important;
}
.v-btn {
  letter-spacing: 0 !important;
}
.v-radio {
  margin-left: 16px !important;
  margin-right: 0 !important;
}
._title {
  border-bottom: 2px solid;
  color: #006298;
  padding-bottom: 2rem;
  margin: 2rem 0;
  text-align: center;
}
.v-input {
  font-size: 1rem !important;
}
.v-input--radio-group--row .v-input--radio-group__input > .v-label {
  padding-right: 0 !important;
  text-align: right;
}
.v-treeview-node__root {
  min-height: 35px !important;
}
.v-treeview .v-icon.mdi-checkbox-marked,
.v-treeview .v-icon.mdi-checkbox-blank-outline {
  font-size: 18px !important;
}
.custom-help-container img {
  width: 100%;
}
</style>
